import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

function MicDrop() {
  const mic = useRef();

  useEffect(() => {
    gsap.to(mic.current, {
      y: "365",
      repeat: "-1",
      duration: "3",
      ease: "bounce",
      yoyoEase: true,
      yoyo: true,
    });
  });

  return (
    <>
      <svg
        width="500"
        height="500"
        viewBox="0 0 488 693"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="micdropSvg"
      >
        <g id="MicDrop" clipPath="url(#clip0_0_1)">
          <path
            id="Vector"
            d="M488 627.759H0V629.759H488V627.759Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_2"
            d="M313.616 192.464C313.616 192.464 292.876 195.917 282.219 193.98C271.563 192.043 250.418 203.036 250.418 203.036L194.541 223.724C194.541 223.724 144 265.134 136.893 236.281C132.912 220.122 185 207.134 185 207.134L276.555 163.278L309.868 151.764L313.616 192.464Z"
            fill="#B06C49"
          />
          <path
            id="Vector_3"
            d="M317.606 313.134L303 327.134L305.606 388.134C305.606 388.134 308.606 468.134 307.606 471.134C306.606 474.134 288.606 596.134 288.606 596.134C288.606 596.134 309.606 606.134 328.606 600.134C328.606 600.134 347.606 510.134 347.606 484.134L369.606 393.134L403.606 497.134C403.606 497.134 405.606 567.134 409.606 590.134C413.606 613.134 413.606 616.134 413.606 616.134C413.606 616.134 445.606 625.134 453.606 616.134C453.606 616.134 449.606 498.134 446.606 486.134L439.606 343.134L317.606 313.134Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_4"
            d="M296.606 596.134C296.606 596.134 294.606 593.134 288.606 601.134C282.606 609.134 263.606 624.134 263.606 624.134C263.606 624.134 211.606 661.134 250.606 663.134C289.606 665.134 296.606 645.134 296.606 645.134C296.606 645.134 329.606 639.134 330.606 632.134C331.606 625.134 326.606 597.134 326.606 597.134L296.606 596.134Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_5"
            d="M415.606 614.134C415.606 614.134 408.606 638.134 410.606 648.134C412.606 658.134 406.606 695.134 434.606 692.134C462.606 689.134 453.606 657.134 453.606 657.134L444.606 616.134L415.606 614.134Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_6"
            d="M376.106 90.634C394.332 90.634 409.106 75.8594 409.106 57.634C409.106 39.4086 394.332 24.634 376.106 24.634C357.881 24.634 343.106 39.4086 343.106 57.634C343.106 75.8594 357.881 90.634 376.106 90.634Z"
            fill="#B06C49"
          />
          <path
            id="Vector_7"
            d="M356.606 75.134C356.606 75.134 366.606 110.134 358.606 123.134C350.606 136.134 412.606 125.134 416.606 113.134C416.606 113.134 396.606 91.134 399.606 70.134L356.606 75.134Z"
            fill="#B06C49"
          />
          <path
            id="Vector_8"
            d="M372.606 122.134C372.606 122.134 399.981 123.985 413.294 109.059L448.91 124.281C452.801 125.944 456.012 128.878 458.019 132.604C460.025 136.33 460.707 140.627 459.953 144.791L441.606 246.134C441.606 246.134 450 310.134 445.606 353.134C441.637 391.983 297.606 353.134 302.606 320.134C303.142 316.598 303.636 312.982 304.092 309.344C308.298 276.84 314.377 244.606 322.299 212.804C324.959 201.939 317.606 140.134 317.606 140.134L361.624 110.969C361.624 110.969 363.606 122.134 372.606 122.134Z"
            fill="#39FF14"
          />
          <path
            id="Vector_9"
            d="M342.931 137.548L334.563 128.947L273.272 163.463C273.272 163.463 291.227 194.825 298.297 194.923C301.007 194.96 333.163 196.533 341 186.134C353.611 169.4 342.931 137.548 342.931 137.548Z"
            fill="#39FF14"
          />
          <path
            id="Vector_10"
            d="M367.999 36.0408C372.896 35.2748 377.833 34.7854 382.786 34.5749C386.374 34.4224 390.112 34.4466 393.355 35.9909C398.244 38.3193 400.984 43.5828 402.777 48.6926C404.57 53.8023 405.843 59.263 409.17 63.5359C414.705 57.7576 415.812 49.1671 416.636 41.2077C417.215 35.6093 417.729 29.6399 415.141 24.6421C413.546 21.5639 410.916 19.1651 408.251 16.9474C395.532 6.3608 379.377 -1.96939 363 0.40841L362.616 2.93686C359.822 2.85284 357.025 3.02859 354.263 3.46185L354.848 9.73486L346.149 10.2867L345.815 16.8244L337.017 17.1294C337.187 19.6417 338.28 22.0024 340.086 23.7566C338.733 24.7344 337.196 25.4287 335.568 25.7976C337.035 31.4766 338.459 37.1686 339.974 42.8349C341.091 47.0089 340.891 50.6968 345.368 48.6598C348.777 47.1088 351.083 42.1767 354.53 40.1389C358.59 37.7382 363.395 36.761 367.999 36.0408Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_11"
            d="M476.339 181.745L476.824 216.988L466.672 317.996C466.672 317.996 472.148 371.399 455.598 373.143C426.046 376.259 447.828 314.657 447.828 314.657L448.307 255.075C448.307 255.075 451.465 231.454 446.024 222.089C440.583 212.724 436.786 192.044 436.786 192.044L476.339 181.745Z"
            fill="#B06C49"
          />
          <path
            id="Vector_12"
            d="M448.606 127.134C452.657 127.133 456.598 128.449 459.836 130.883C463.073 133.317 465.432 136.738 466.556 140.629C472.942 162.758 484.541 204.4 481.606 205.134C477.606 206.134 430.606 209.134 430.606 209.134L448.606 127.134Z"
            fill="#39FF14"
          />
          <g id="mic" ref={mic}>
            <path
              id="Vector_13"
              d="M97.1285 235.544L97.3697 235.602C101.736 236.656 105.659 239.062 108.578 242.476C111.498 245.89 113.265 250.138 113.628 254.615C113.992 259.093 112.933 263.57 110.602 267.411C108.271 271.251 104.788 274.257 100.648 276.001C99.0194 276.692 97.3098 277.175 95.56 277.437C92.4539 277.911 89.2815 277.694 86.2693 276.8C83.2571 275.906 80.4795 274.358 78.1348 272.266C75.79 270.175 73.9361 267.591 72.7053 264.7C71.4746 261.809 70.8974 258.682 71.0149 255.542C71.1325 252.403 71.942 249.327 73.3855 246.537C74.829 243.746 76.8709 241.308 79.3654 239.398C81.86 237.487 84.7456 236.151 87.8162 235.485C90.8868 234.819 94.0666 234.839 97.1285 235.544V235.544Z"
              fill="#39FF14"
            />
            <path
              id="Vector_14"
              d="M97.1285 235.544C99.1955 248.937 100.371 262.453 100.648 276.001C99.0194 276.693 97.3098 277.175 95.56 277.437C95.6869 263.207 94.4457 248.998 91.8533 235.006C93.6273 234.965 95.3994 235.146 97.1285 235.544Z"
              fill="#E6E6E6"
            />
            <path
              id="Vector_15"
              d="M182.065 239.999L108.862 242.97L110.924 267.202L183.676 256.229C184.968 256.05 186.138 255.374 186.937 254.343C187.736 253.312 188.1 252.01 187.951 250.715L187.852 249.859L190.724 249.739C191.077 249.725 191.422 249.636 191.738 249.48C192.054 249.323 192.334 249.102 192.559 248.831C192.785 248.56 192.951 248.244 193.046 247.904C193.142 247.565 193.165 247.209 193.115 246.86L193.097 246.738C193.004 246.093 192.664 245.508 192.149 245.108C191.634 244.708 190.984 244.523 190.335 244.592L187.283 244.917L187.226 244.415C187.082 243.164 186.47 242.013 185.513 241.194C184.555 240.375 183.324 239.948 182.065 239.999Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_16"
              d="M141.517 254.265C141.441 254.579 141.265 254.861 141.015 255.066C140.765 255.272 140.455 255.39 140.132 255.403L134.874 255.621C134.515 255.635 134.164 255.519 133.884 255.295C133.604 255.072 133.414 254.755 133.348 254.402L132.815 251.497C132.778 251.295 132.783 251.088 132.83 250.889C132.876 250.689 132.964 250.501 133.087 250.337C133.209 250.173 133.364 250.036 133.543 249.935C133.721 249.833 133.918 249.77 134.121 249.748L139.441 249.181C139.825 249.139 140.209 249.248 140.514 249.484C140.818 249.721 141.018 250.066 141.072 250.448L141.072 250.448L141.543 253.703C141.57 253.89 141.561 254.081 141.517 254.265ZM133.796 251.112C133.78 251.179 133.778 251.249 133.791 251.318L134.324 254.223C134.346 254.341 134.409 254.446 134.503 254.521C134.596 254.596 134.713 254.634 134.832 254.63L140.09 254.412C140.16 254.409 140.228 254.392 140.29 254.361C140.352 254.33 140.407 254.286 140.452 254.233C140.496 254.179 140.529 254.117 140.547 254.05C140.566 253.984 140.571 253.914 140.561 253.845L140.09 250.59C140.072 250.463 140.005 250.348 139.904 250.269C139.802 250.19 139.674 250.154 139.547 250.168L134.226 250.735C134.158 250.742 134.093 250.763 134.033 250.796C133.974 250.83 133.922 250.876 133.882 250.931C133.841 250.985 133.812 251.046 133.796 251.112Z"
              fill="#E6E6E6"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_0_1">
            <rect width="488" height="692.307" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export default MicDrop;
